import axios from 'axios'

/**
 * バージョンサービス
 */
export default class VersionService {
    /** インスタンス */
    private static _instance: VersionService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new VersionService();
        }
        return this._instance;
    }

    /**
     * バージョン番号を取得
     */
    public async getVersion(): Promise<string> {
        return await axios.get("/api/version")
            .then((results) => {
                if (results.status === 200) {
                    return results.data
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
